import React from 'react';
import { Section } from './Section';
import { X } from 'lucide-react';
export function WhyItFails() {
  const failures = [{
    quote: '"Duerme cuando el bebé duerme"',
    reason: 'Como si fuera tan simple cuando hay mil cosas por hacer'
  }, {
    quote: '"Ya se te va a pasar"',
    reason: 'Sin decirte cuándo ni cómo ayudar a que eso suceda'
  }, {
    quote: 'Las dietas genéricas',
    reason: 'No consideran que tu cuerpo posparto tiene necesidades completamente diferentes'
  }, {
    quote: 'Los consejos de redes sociales',
    reason: 'Te muestran mamás perfectas que solo aumentan tu culpa'
  }, {
    quote: 'Los libros de autoayuda normales',
    reason: 'No están escritos para una mujer con un bebé, cero tiempo y energía limitada'
  }];
  return <Section className="bg-cream-dark/20 rounded-3xl my-12" data-id="element-200">
      <div className="max-w-4xl mx-auto" data-id="element-201">
        <h2 className="text-3xl md:text-4xl text-center mb-4" data-id="element-202">
          No es tu culpa que no hayas sanado todavía.
        </h2>
        <p className="text-xl text-center text-brown-light mb-12 font-serif italic" data-id="element-203">
          Es que nadie te ha dado las herramientas correctas.
        </p>

        <div className="space-y-6 mb-16" data-id="element-204">
          {failures.map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-6 rounded-2xl shadow-sm" data-id="element-205">
              <div className="bg-rose/10 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-206">
                <X className="w-5 h-5 text-rose-dark" data-id="element-207" />
              </div>
              <div data-id="element-208">
                <p className="font-medium text-lg line-through decoration-rose/40 decoration-2 mb-1" data-id="element-209">
                  {item.quote}
                </p>
                <p className="text-brown-light" data-id="element-210">{item.reason}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center bg-white/80 p-8 rounded-2xl shadow-sm border border-rose/10" data-id="element-211">
          <p className="text-2xl font-serif text-rose-dark mb-2" data-id="element-212">
            El problema no eres tú.
          </p>
          <p className="text-lg text-brown-light" data-id="element-213">
            El problema es que el mundo habla mucho del embarazo y muy poco de
            lo que viene después.
          </p>
        </div>
      </div>
    </Section>;
}